import { render, staticRenderFns } from "./PublishDate.vue?vue&type=template&id=276b28da&"
import script from "./PublishDate.vue?vue&type=script&lang=js&"
export * from "./PublishDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports